import { Component } from '@angular/core';

@Component({
  selector: 'app-fieldset-accordion-item',
  templateUrl: './fieldset-accordion-item.component.html',
})
export class FieldsetAccordionItemComponent { }
